export enum Language {
  // DE = 'de',
  EN = 'en',
  // FR = 'fr',
  HR = 'hr',
  // IT = 'it',
}
